import { AlertTriangle } from "lucide-react";

/**
 * CatalogMachinesGrid — secondary list of generic catalog machine categories
 * the user does NOT own; picking one shows a warning that the quote will use
 * the catalog tariff instead of a real workshop hourly_rate.
 */
export default function CatalogMachinesGrid({
  t,
  otherCategoryMachines,
  ownedMachines,
  toggleMachine,
}) {
  if (otherCategoryMachines.length === 0) return null;
  return (
    <div data-testid="catalog-machines-grid">
      <h3 className="font-display font-semibold text-sm text-slate-400 uppercase tracking-wider mb-3">
        {t("newQuote.otherCatalog", { defaultValue: "Altre categorie dal catalogo" })}
      </h3>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
        {otherCategoryMachines.map((m) => {
          const checked = ownedMachines.includes(m.id);
          return (
            <label
              key={m.id}
              className={`flex items-start gap-3 p-4 rounded-md border cursor-pointer transition-all ${
                checked
                  ? "border-amber-500 bg-amber-500/10"
                  : "border-slate-700 hover:border-slate-500 bg-slate-900/40"
              }`}
              data-testid={`machine-${m.id}`}
            >
              <input
                type="checkbox"
                checked={checked}
                onChange={() => toggleMachine(m.id)}
                className="mt-1 w-4 h-4 accent-amber-500"
              />
              <div className="flex-1">
                <div className="flex items-center justify-between">
                  <div className="font-display font-semibold text-slate-100">{m.name}</div>
                  <div className="font-mono-data text-amber-400 text-sm">€{m.hourly_rate}/h</div>
                </div>
                <div className="text-xs text-slate-500 mt-1">{m.category} · ±{m.precision_um}µm</div>
                {checked && (
                  <div
                    className="mt-2 text-xs text-amber-300/90 flex items-start gap-1.5"
                    data-testid={`machine-warning-${m.id}`}
                  >
                    <AlertTriangle size={11} className="mt-0.5 flex-shrink-0" />
                    <span>
                      {t("newQuote.notInWorkshop", {
                        defaultValue:
                          "Questa macchina non è tra le tue macchine. Il calcolo userà la tariffa del catalogo.",
                      })}
                    </span>
                  </div>
                )}
                <div className="mt-2 flex flex-wrap gap-1">
                  {m.capability_labels.slice(0, 4).map((c) => (
                    <span
                      key={`${m.id}-cap-${c}`}
                      className="text-[10px] label-tech px-2 py-0.5 rounded bg-slate-800 border border-slate-700"
                    >
                      {c}
                    </span>
                  ))}
                  {m.capability_labels.length > 4 && (
                    <span className="text-[10px] text-slate-500">+{m.capability_labels.length - 4}</span>
                  )}
                </div>
              </div>
            </label>
          );
        })}
      </div>
    </div>
  );
}
